import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from '@kostbar/i18n'
import { ProductForm } from '../components/product-form'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { PermissionGate } from '@/shared/components/permission-gate'
import { ACTIONS } from '@/shared/constants/actions'

export function ProductCreatePage() {
  const navigate = useNavigate()
  const { t: tProducts } = useTranslation('products')

  const handleCancel = () => {
    navigate({ to: '/products' })
  }

  return (
    <PermissionGate action={ACTIONS.PRODUCT_CREATE}>
      <div>
        <div className="mb-6">
          <h1 className="text-3xl font-bold">{tProducts('create.title')}</h1>
          <p className="text-muted-foreground mt-2">
            {tProducts('create.subtitle')}
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{tProducts('create.detailsTitle')}</CardTitle>
            <CardDescription>
              {tProducts('create.detailsDescription')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ProductForm mode="create" onCancel={handleCancel} />
          </CardContent>
        </Card>
      </div>
    </PermissionGate>
  )
}
